<template>
    <div id="wrap-manage-papers">
        <cm-back
        sectionTitle="Manage papers"
        :contentName="meetup ? meetup.name : 'Loading...'"
        action="true"
        ></cm-back>
        <div
            class="main-manage flex-wrap flex-lg-nowrap justify-content-xl-between flex-xl-row-reverse flex-column align-items-center align-items-xl-start"
        >
            <!-- <aside class="agenda-cta ml-xl-3" >
                <div>
                    <div
                        class="mt-2 mt-md-0"
                    >Want to schedule activities and arrange papers for this meetup?</div>
                    <button
                        class="btn btn-primary btn-sm mt-2 mt-md-0 mt-xl-2 ml-0 ml-md-2"
                    >Go to agenda builder</button>
                </div>
            </aside>-->
            <section class="papers-table mx-auto mt-3">
                <papers-table
                    :papers="papers"
                    :fields="fields"
                    type="meetup"
                    :loading="loadingPapers"
                    :page="papersPage"
                    :total="papersTotal"
                    :perPage="papersPerPage"
                    :changePage="changePage"
                    :approve="approvePaper"
                    :reject="rejectPaper"
                    @page-changed="val => papersPage = val"
                ></papers-table>
            </section>
            <md-dialog-alert
                md-title="Update result"
                class="update-result-dialog"
                :md-active.sync="updateResult"
                :md-content="updateResultText"
                @md-closed="loadPapers"
            ></md-dialog-alert>
        </div>
    </div>
</template>
<script>
import PapersTable from "@/components/Papers/PapersTable.vue";
import CmBack from "@/components/CmBack.vue";

export default {
    name: "manage-submissions",
    components: {
        PapersTable,
        CmBack
    },
    async mounted() {
        if (!this.community) {
            this.loadingPapers = true;
            try {
                this.$store.commit(
                    "setCommunity",
                    await this.$communityApi.getCommunity(this.$route.params.id)
                );
            } catch (error) {
                this.$router.replace({
                    name: "communities"
                });
            }
            try {
                this.$store.commit(
                    "setMeetup",
                    (await this.$meetupApi.getMeetupById(
                        this.$route.params.meetupid
                    )).data
                );
            } catch (error) {
                this.$router.replace({
                    name: "communities"
                });
            }
        }
        this.loadPapers();
    },
    data: () => ({
        loadingPapers: false,
        papersPage: 1,
        papersTotal: 0,
        papersPerPage: 10,
        updateResult: false,
        updateResultText: "",
        fields: [
            { key: "speaker", label: "Speaker" },
            { key: "title", label: "Paper Title" },
            { key: "length", label: "Length" },
            { key: "level", label: "Level" },
            { key: "actions", label: "" }
        ],
        papers: []
    }),
    methods: {
        async approvePaper(paper) {
            if (paper.state === "WAITING_FOR_APPROVAL") {
                try {
                    this.loadingPapers = true;
                    await this.$meetupApi.approveProposal(this.meetup.id ,paper.id);
                    this.updateResultText = "Paper successfully approved!";
                    this.updateResult = true;
                    return true;
                } catch (error) {
                    this.updateResultText = error.message;
                    console.error(error);
                    this.updateResult = true;
                    return false;
                } finally {
                    this.loadingPapers = false;
                } 
            }
        },
        async rejectPaper(paper) {
            if (paper.state === "WAITING_FOR_APPROVAL") {
                try {
                    this.loadingPapers = true;
                    await this.$meetupApi.rejectProposal(this.meetup.id ,paper.id);
                    this.updateResultText = "Operation completed.";
                    this.updateResult = true;
                    return true;
                } catch (error) {
                    this.updateResultText = error.message;
                    console.error(error);
                    this.updateResult = true;
                    return false;
                } finally {
                    this.loadingPapers = false;
                }
            }
        },
        changePage(page) {
            this.papersPage = page;
            this.loadPapers();
        },
        async loadPapers() {
            this.papers = [];
            this.loadingPapers = true;
            try {
                const papersData = await this.$meetupApi.getMeetupProposals(
                    this.$route.params.meetupid,
                    this.papersPage,
                    10
                );
                this.papersTotal = papersData.total;
                this.papers = papersData.data;
            } catch (error) {
                console.error(error);
            }
            this.loadingPapers = false;
        }
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        meetup() {
            return this.$store.getters.meetup;
        }
    }
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
#wrap-manage-submissions {
    .wrap-title-breadscrumbs {
        line-height: 1.2;
    }

    .main-manage {
        display: flex;
        justify-content: center;
        max-width: 1440px;
        padding: 0 15px;
        margin: 0 auto;
        @media all and (min-width: 1200px) {
            padding: 30px 15px;
        }
    }
    .agenda-cta {
        width: 100%;
        max-width: 1000px;
        & > div {
            flex-wrap: wrap;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
            text-align: center;
            @media all and (min-width: 991px) {
                justify-content: flex-end;
                padding: 10px 0;
            }
            button {
                margin-left: 15px;
            }
        }
        @media all and (min-width: 1200px) {
            max-width: 250px;
            & > div {
                width: 100%;
                box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
                border-radius: 5px;
                justify-content: center;
                flex-direction: column;
                padding: 10px;

                button {
                    margin-left: 0;
                    margin-top: 15px;
                }
            }
        }
    }
    .papers-table {
        max-width: 1000px;
        width: 100%;
    }
}
.update-result-dialog {
    z-index: 1200 !important;
}
</style>